export default (name: string | undefined) => {
    const key = (name || "").trim().toLowerCase();
    switch (key) {
        case "ball":
            return "/images/sketches/stone-shapes/ball.png";
        case "button":
            return "/images/sketches/stone-shapes/button.png";
        case "butterfly":
            return "/images/sketches/stone-shapes/butterfly.png";
        case "fancy 4c":
            return "/images/sketches/stone-shapes/fancy-4c.png";
        case "fancy 5c":
            return "/images/sketches/stone-shapes/fancy-5c.png";
        case "other":
            return "/images/sketches/stone-shapes/other.png";
        case "pear":
            return "/images/sketches/stone-shapes/pear.png";
        case "oval":
            return "/images/sketches/stone-shapes/oval.png";
        case "fancy":
            return "/images/sketches/stone-shapes/fancy.png";
        case "heart":
            return "/images/sketches/stone-shapes/heart.png";
        case "round":
            return "/images/sketches/stone-shapes/round.png";
        case "flower":
            return "/images/sketches/stone-shapes/flower.png";
        case "drop":
            return "/images/sketches/stone-shapes/drop.png";
        case "marquise":
            return "/images/sketches/stone-shapes/marquise.png";
        case "trillion":
            return "/images/sketches/stone-shapes/trillion.png";
        case "square":
            return "/images/sketches/stone-shapes/square.png";
        case "asscher":
            return "/images/sketches/stone-shapes/asscher.png";
        case "rectangular":
            return "/images/sketches/stone-shapes/rectangular.png";
        case "octagon":
            return "/images/sketches/stone-shapes/octagon.png";
        case "cushion":
            return "/images/sketches/stone-shapes/asscher.png";
        case "baguette":
            return "/images/sketches/stone-shapes/baguette.png";
        case "diamond":
            return "/images/sketches/stone-shapes/diamond.png";

        default:
            return "/images/sketches/stone-shapes/diamond.png";
    }
};
